import get from 'lodash/get';
import { muiThemeLuma } from 'themes';

const mapTypes = {
  cake: {
    color: muiThemeLuma.custom.palette.colorAccentLuma,
  },
  diagnoses: {
    iconName: 'assignment',
    color: muiThemeLuma.custom.palette.colorAccentLuma,
  },
  procedures: {
    iconName: 'airline_seat_individual_suite',
    color: muiThemeLuma.palette.primary.main,
  },
  appointments: {
    iconName: 'event',
    color: muiThemeLuma.custom.palette.colorDarkCyan,
  },
  referrals: {
    iconName: 'person_add',
    color: muiThemeLuma.custom.palette.colorSuccess,
  },
  feedbackResponses: {
    iconName: 'star_rate',
    color: muiThemeLuma.custom.palette.colorAccentSky,
  },
  insurances: {
    iconName: 'note',
    color: muiThemeLuma.custom.palette.colorGrayishBlue,
  },
  type: {
    iconName: 'event',
    color: muiThemeLuma.custom.palette.colorDarkCyan,
  },
  provider: {
    iconName: 'person',
  },
  facility: {
    iconName: 'business',
  },
  feedback: {
    iconName: 'star_rate',
    color: muiThemeLuma.custom.palette.colorAccentSky,
  },
  recalls: {
    iconName: 'autorenew',
    color: muiThemeLuma.custom.palette.colorSupportSlate,
  },
  patientForms: {
    iconName: 'book',
    color: muiThemeLuma.custom.palette.colorAccentLuma,
  },
  memberName: {
    iconName: 'face',
    color: muiThemeLuma.custom.palette.colorGrayishBlue,
  },
  memberNumber: {
    iconName: 'person',
    color: muiThemeLuma.custom.palette.colorGrayishBlue,
  },
  insuranceGroupName: {
    iconName: 'group',
    color: muiThemeLuma.custom.palette.colorGrayishBlue,
  },
  planName: {
    iconName: 'local_hospital',
    color: muiThemeLuma.custom.palette.colorGrayishBlue,
  },
  billingTransactions: {
    iconName: 'attach_money',
    color: muiThemeLuma.custom.palette.colorAccentTeal,
  },
};

export function getEventTypeProps(type) {
  if (!type) {
    return;
  }
  return {
    iconName: get(mapTypes, `${type}.iconName`, type),
    color: get(mapTypes, `${type}.color`, muiThemeLuma.palette.primary.main),
  };
}
